var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCertificateFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 142,
  viewBox: "0 0 130 142",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/certificate_filled.svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 21,
  width: 48,
  height: 60,
  rx: 5,
  fill: "#005FF9",
  stroke: "#005FF9",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 36,
  width: 22,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 42,
  width: 16,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 30,
  width: 30,
  height: 2,
  rx: 1,
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/certificate_filled.svg__filter0_d",
  x: 0,
  y: 0,
  width: 130,
  height: 142,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgCertificateFilled as ReactComponent };